/* eslint-disable */
import axios from 'axios'

const getData = (e) => e.data

const apiMy = process.env.VUE_APP_API_URI;
// const apiMy = 'http://localhost:3000'

const api = {
  deleteAccountDemand: (user_email) => axios.post(`${apiMy}/delete_account`, {email: user_email}),
  weather: {
    getModels: (geoname) =>
      axios.get(`${apiMy}/model/${geoname}`).then(getData),
    get: () =>
      axios
        .get(
          `${apiMy}/rainviewer/weather`,
        )
        .then(getData),
  },
  documents:{
    post: (data) => axios.post(`${apiMy}/documents`, data),
  },
  users: {
    getAll: () =>
      axios
        .get(`https://auth.previmeteo.net/users?per_page=100000`)
        .then(getData),
    get: (id) => axios.get(`${apiMy}/users/${id}`).then(getData),
    me: () => axios.get(`https://auth.previmeteo.net/user/me`).then(getData),
    getUploadedFiles: (id_user) => axios.get(`${apiMy}/users/uploaded_files/${id_user}`).then(getData),
    subsfavorite: (id_user, data) =>
      axios.post(`${apiMy}/users/${id_user}/favorites`, data),
    unsubsfavorite: (id_user, id_favoris) =>
      axios.delete(`${apiMy}/users/${id_user}/favorites/${id_favoris}`),
    updateData: (id, data) => axios.put(`${apiMy}/users/${id}`, data),
    updateLang: (id, lang) => axios.put(`${apiMy}/update_lang/${id}/${lang}`),
    updateEmail: (id, data) =>
      axios.put(`${apiMy}/users/${id}/change_email`, data),
    updatePassword: (id, data) =>
      axios.put(`${apiMy}/users/${id}/change_password`, data),
    updateRole: (id_user, id_role) =>
      axios.put(`${apiMy}/update_role/${id_user}/${id_role}`).then(getData),
    lostPassword: (user_email) =>
      axios
        .get(`https://auth.previmeteo.net/users/${user_email}/lost_password`)
        .then(getData),
  },
  cities: {
    search: (data) => axios.get(`${apiMy}/cities?search=${data}`).then(getData),
    getinfos: (geoname) => axios.get(`${apiMy}/city/${geoname}`).then(getData),
  },
  stations: {
    getOne: (id_station, from, to) =>
      axios
        .get(
          `${apiMy}/stations/${id_station}/data${
            from ? `?from=${from}&to=${to}` : ''
          }`,
        )
        .then(getData),
    getExportUrl: (id_station, from, to) => {
      return `${apiMy}/stations/${id_station}/export${
        from ? `?from=${from}&to=${to}` : ''
      }`
    },
    getCountries: () => axios.get(`${apiMy}/countries`).then(getData),
    getTimezones: () => axios.get(`${apiMy}/timezones`).then(getData),
    getConnectors: () =>
      axios.get(`${apiMy}/stations/connectors`).then(getData),
    createStation: (id_user, data) =>
      axios.post(`${apiMy}/users/${id_user}/stations/connect`, data),
    activate: (id_station) =>
      axios.get(`${apiMy}/stations/${id_station}/activate`).then(getData),
    disable: (id_station) =>
      axios.get(`${apiMy}/stations/${id_station}/disable`).then(getData),
  },
  notifications: {
    post: (id_user, token) =>
      axios
        .post(`${apiMy}/notifications`, { id_user: id_user, token: token })
        .then(getData),
  },
  forecast: {
    get: (geoname, freq = 3, model = null) =>
      axios
        .get(`${apiMy}/forecasts/${geoname}/${model || 'false'}?freq=${freq}`)
        .then(getData),
    getMulti: (geoname) =>
      axios.get(`${apiMy}/forecasts/${geoname}/get/multi`).then(getData),
    getByLatLng: (lat, lng) =>
      axios.get(`${apiMy}/forecastsByLatLng/${lat}/${lng}`).then(getData),
    getAlerts: (id_user, geoname) =>
      axios
        .get(`${apiMy}/users/${id_user}/alerts_level/${geoname}`)
        .then(getData),
    getText:(search)=>axios.get(`${apiMy}/meteo-txt/${search}`).then(getData)
  },
  roadcast: {
    get: (lat, lng) =>
      axios
        .get(`https://roadcast.previmeteo.net/previmeteo/${lat}/${lng}`)
        .then(getData),
  },
  alert: {
    get: (id_user) =>
      axios.get(`${apiMy}/users/${id_user}/alerts/list`).then(getData),
    getMapAlerts: (id_user) =>
      axios.get(`${apiMy}/users/${id_user}/alerts`).then(getData),
    createAlert: (id_user, geoname, data) =>
      axios.post(`${apiMy}/users/${id_user}/geoname/${geoname}/alerts`, data),
    updateAlert: (id_user, id_alert, data) =>
      axios.put(`${apiMy}/users/${id_user}/alerts/${id_alert}`, data),
    deleteAlert: (id_user, id_alert) =>
      axios.delete(`${apiMy}/users/${id_user}/alerts/${id_alert}`),
    readAll: (id_user) =>
      axios.post(`${apiMy}/users/${id_user}/alerts/read`).then(getData),
  },
  bulletin: {
    get: (cityname) =>
      axios.post(`${apiMy}/bulletin`, { cityname: cityname }).then(getData),
    subscribe: (id_user, data) =>
      axios.post(`${apiMy}/users/${id_user}/bulletins_pdf`, data),
    unsubscribe: (id_user, id_bulletin) =>
      axios.delete(`${apiMy}/users/${id_user}/bulletins_pdf/${id_bulletin}`),
  },
  referrer: {
    get: (user_id) =>
      axios.get(`${apiMy}/users/${user_id}/referrers`).then(getData),
    invite: (data) => axios.post(`${apiMy}/invite`, data),
  },
  auth_magic: (token) =>
    axios
      .get(`https://auth.previmeteo.net/auth/magic?token=${token}`)
      .then(getData),
  loginAs: (email) =>
    axios
      .post(`https://auth.previmeteo.net/auth/local`, { email })
      .then(getData),
  login: (email, password) =>
    axios
      .post('https://auth.previmeteo.net/auth/local', { email, password })
      .then(getData),
  registerUser: (data) =>
    axios.post('https://auth.previmeteo.net/users', data).then(getData),
  registerFreeTest: (id_user) =>
    axios.post(`${apiMy}/users/${id_user}/activate_free_test`).then(getData),
  confirm_email: (user_email) =>
    axios.get(`${apiMy}/users/${user_email}/confirm_email`).then(getData),
}

export default api
